import type { ApiOkBase } from '../types/api';
import type { EmissionScheduleClient } from '../types/venta-form';
import { fetchJson } from './http-client';

interface EmissionScheduleResponse extends ApiOkBase {
  fechaEmision?: string;
  beforeCutoff?: boolean;
  cutoffLabel?: string;
  error?: string;
}

export async function fetchEmissionSchedule(): Promise<EmissionScheduleClient> {
  const result = await fetchJson<EmissionScheduleResponse>('/api/autorizaciones/emision-schedule', {
    headers: { Accept: 'application/json' },
  });
  if (!result.data.ok || !result.data.fechaEmision) {
    throw new Error(result.data.error || 'Error');
  }
  return {
    fechaEmision: result.data.fechaEmision,
    beforeCutoff: result.data.beforeCutoff,
    cutoffLabel: result.data.cutoffLabel,
  };
}
